import { useEffect, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";

export function usePolling(queryKeys: string[][], intervalMs = 30_000) {
  const queryClient = useQueryClient();
  const keysRef = useRef(queryKeys);
  keysRef.current = queryKeys;

  useEffect(() => {
    const id = setInterval(() => {
      for (const key of keysRef.current) {
        queryClient.invalidateQueries({ queryKey: key });
      }
    }, intervalMs);
    return () => clearInterval(id);
  }, [queryClient, intervalMs]);
}
